import { createAppKit } from '@reown/appkit/react';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { bsc, bscTestnet, mainnet } from '@reown/appkit/networks';
import { http } from 'viem';
import { getBscRpcUrl } from './wait-for-usdt-transfer';

const projectId = import.meta.env.VITE_REOWN_PROJECT_ID ?? '';
const testnetEnabled = import.meta.env.VITE_TP_RECHARGE_TESTNET === 'true';

const networks = testnetEnabled ? [bsc, bscTestnet, mainnet] : [bsc, mainnet];

const origin =
  typeof window !== 'undefined' ? window.location.origin : 'https://orb-player-pwa.vercel.app';

const transports: Record<number, ReturnType<typeof http>> = {
  [bsc.id]: http(getBscRpcUrl()),
  [mainnet.id]: http(),
};
if (testnetEnabled) transports[bscTestnet.id] = http();

export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  transports,
});

createAppKit({
  adapters: [wagmiAdapter],
  networks: networks as [typeof bsc, ...(typeof bsc)[]],
  projectId,
  metadata: {
    name: 'ORB Platform',
    description: 'ORB 能量测',
    url: origin,
    icons: [`${origin}/orbit.png`],
  },
  themeMode: 'dark',
  features: {
    analytics: false,
  },
});

export const wagmiConfig = wagmiAdapter.wagmiConfig;

export function isWalletLoginConfigured(): boolean {
  return projectId.length > 0;
}
